import { useSelector } from 'react-redux';
import { Cell, Image, Rating, Spacer, Text } from '@vinted/web-ui';
import UserImage from 'components/UserImage';
import UserTitle from 'components/UserTitle';
import useTranslate from 'hooks/useTranslate';
import { MEMBER_PROFILE_URL } from 'constants/routes';
import { calculateRating } from 'data/utils/user';
import * as selectors from 'state/auth/selectors';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const SelectTypeHeader = _ref => {
  var _referrer$photo, _referrer$business_ac;

  let {
    referrer
  } = _ref;
  const isLoginView = useSelector(selectors.getIsSelectTypeLogin);
  const isBusinessAuth = useSelector(selectors.getIsBusinessAuth);
  const authTranslate = useTranslate("auth.select_type.".concat(isLoginView ? 'login' : 'register'));
  const businessTranslate = useTranslate('business.account');
  const userFeedbackTranslate = useTranslate('user.feedback');

  const renderSubtitle = () => {
    if (!isBusinessAuth) return null;
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Spacer, {
        size: Spacer.Size.Large
      }), /*#__PURE__*/_jsx(Text, {
        width: Text.Width.Parent,
        alignment: Text.Alignment.Center,
        children: businessTranslate('subtitle')
      })]
    });
  };

  const renderTitle = () => {
    return /*#__PURE__*/_jsx(Text, {
      id: "auth_modal_title",
      text: isBusinessAuth ? businessTranslate('title') : authTranslate('title'),
      type: Text.Type.Heading,
      alignment: Text.Alignment.Center,
      width: Text.Width.Parent
    });
  };

  if (!referrer || isLoginView) {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [renderTitle(), renderSubtitle()]
    });
  }

  const rating = calculateRating(referrer.feedback_reputation);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("div", {
      className: "u-flexbox u-justify-content-center",
      children: /*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsx(Cell, {
          clickable: true,
          styling: Cell.Styling.Tight,
          prefix: /*#__PURE__*/_jsx(UserImage, {
            src: (_referrer$photo = referrer.photo) === null || _referrer$photo === void 0 ? void 0 : _referrer$photo.url,
            styling: Image.Styling.Circle,
            size: Image.Size.Large
          }),
          title: /*#__PURE__*/_jsx(UserTitle, {
            businessAccountName: (_referrer$business_ac = referrer.business_account) === null || _referrer$business_ac === void 0 ? void 0 : _referrer$business_ac.name,
            login: referrer.login,
            isBusiness: referrer.business,
            isBody: true,
            isBottomLoginHidden: true,
            isBadgeHidden: true
          }),
          url: MEMBER_PROFILE_URL(referrer.id),
          children: /*#__PURE__*/_jsx(Rating, {
            value: rating,
            text: userFeedbackTranslate('reviews', {
              count: referrer.feedback_count
            }, {
              count: referrer.feedback_count
            }),
            size: Rating.Size.Regular,
            emptyStateText: userFeedbackTranslate('no_reviews')
          })
        })
      })
    }), /*#__PURE__*/_jsx(Spacer, {
      size: Spacer.Size.Large
    }), /*#__PURE__*/_jsx(Text, {
      text: authTranslate('referrer_title', {
        username: referrer.login
      }),
      type: Text.Type.Heading,
      alignment: Text.Alignment.Center,
      width: Text.Width.Parent
    })]
  });
};

export default SelectTypeHeader;